import React, { useState } from "react";
import styled from "styled-components";
import BookCard from "./BookCard";

// 데이터 (이모지 및 카테고리 정보 포함)
const INITIAL_BOOKS = [
    { id: 1, title: "리액트의 정석", author: "김민주", price: 25000, category: "IT/개발", cover: "https://image.aladin.co.kr/product/29547/4/cover500/k982837150_1.jpg", desc: "리액트의 A to Z" },
    { id: 2, title: "모던 자바스크립트", author: "이웅모", price: 45000, category: "IT/개발", cover: "https://image.aladin.co.kr/product/25155/25/cover500/k282633473_1.jpg", desc: "JS 딥다이브" },
    { id: 3, title: "UX 디자인 원칙", author: "도널드 노먼", price: 18000, category: "디자인", cover: "https://image.aladin.co.kr/product/32692/95/cover500/k862936564_2.jpg", desc: "사용자 경험 바이블" },
    { id: 4, title: "알고리즘 인터뷰", author: "나동빈", price: 35000, category: "IT/개발", cover: "https://image.aladin.co.kr/product/18386/82/cover500/8970509712_1.jpg", desc: "취업 알고리즘" },
    { id: 5, title: "미라클 모닝", author: "할 엘로드", price: 15000, category: "자기계발", cover: "https://image.aladin.co.kr/product/24059/74/cover500/k162639038_2.jpg", desc: "아침의 기적" },
    { id: 6, title: "돈의 심리학", author: "모건 하우절", price: 19800, category: "경제/경영", cover: "https://image.aladin.co.kr/product/32852/7/cover500/k132936910_2.jpg", desc: "부의 비밀" },
];

const Container = styled.div`
    max-width: 1200px;
    margin: 2rem auto;
    padding: 0 1rem;
`;

const SearchWrapper = styled.div`
    background: ${(props) => (props.theme === "light" ? "white" : "#374151")};
    border: 1px solid ${(props) => (props.theme === "light" ? "#e5e7eb" : "#4b5563")};
    border-radius: 0.5rem;
    padding: 0.75rem;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 2rem;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
`;

const SearchInput = styled.input`
    border: none;
    outline: none;
    font-size: 1rem;
    width: 100%;
    background: transparent;
    color: ${(props) => (props.theme === "light" ? "#374151" : "white")};
    
    &::placeholder {
        color: #9ca3af;
    }
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 1.5rem;
`;

function ShopPage({ theme, addToCart, onViewDetail, convertPrice }) {
    const [searchTerm, setSearchTerm] = useState("");

    const filteredBooks = INITIAL_BOOKS.filter(book =>
        book.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        book.author.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <Container>
            <SearchWrapper theme={theme}>
                <span style={{fontSize:"1.2rem"}}>🔍</span>
                <SearchInput
                    type="text"
                    placeholder="도서명 또는 저자를 검색하세요..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    theme={theme}
                />
            </SearchWrapper>

            <Grid>
                {filteredBooks.map((book) => (
                    <BookCard
                        key={book.id}
                        book={book}
                        theme={theme}
                        onAddToCart={addToCart}
                        onViewDetail={onViewDetail}
                        convertPrice={convertPrice}
                    />
                ))}
            </Grid>
        </Container>
    );
}

export default ShopPage;